import React from 'react';
import { Document, Page, Text, View, Image } from '@react-pdf/renderer';
import { sharedStyles } from './SharedPDFStyles';

const TerziReportPDF = ({ data, logos }) => {
  return (
    <Document>
      <Page size="A4" style={sharedStyles.page}>
        <View style={sharedStyles.header}>
          <View style={sharedStyles.businessInfo}>
            {logos.length > 0 && (
              <View style={sharedStyles.logoContainer}>
                {logos.slice(0, 3).map((logo, index) => (
                  <Image key={index} src={logo.data} style={sharedStyles.logo} />
                ))}
              </View>
            )}
            <Text style={sharedStyles.businessName}>{data.shopName || 'Shop Name'}</Text>
            <Text style={sharedStyles.businessDetails}>{data.address}</Text>
            <Text style={sharedStyles.businessDetails}>{data.contactInfo}</Text>
          </View>
          <View style={sharedStyles.documentTitle}>
            <Text style={sharedStyles.title}>Sales Invoice</Text>
            <Text style={sharedStyles.documentInfo}>Date: {data.date}</Text>
            <Text style={sharedStyles.documentInfo}>Customer: {data.customerName}</Text>
          </View>
        </View>

        <View style={sharedStyles.section}>
          <View style={sharedStyles.table}>
            <View style={sharedStyles.tableHeader}>
              <Text style={{ ...sharedStyles.tableCell, flex: 2 }}>Item Name</Text>
              <Text style={sharedStyles.tableCell}>Category</Text>
              <Text style={sharedStyles.tableCellCenter}>Qty</Text>
              <Text style={sharedStyles.tableCellRight}>Unit Price</Text>
              <Text style={sharedStyles.tableCellRight}>Total</Text>
            </View>
            {data.items && data.items.map((item, index) => (
              <View key={index} style={sharedStyles.tableRow}>
                <Text style={{ ...sharedStyles.tableCell, flex: 2 }}>{item.itemName}</Text>
                <Text style={sharedStyles.tableCell}>{item.category}</Text>
                <Text style={sharedStyles.tableCellCenter}>{item.quantity}</Text>
                <Text style={sharedStyles.tableCellRight}>${item.unitPrice.toFixed(2)}</Text>
                <Text style={sharedStyles.tableCellRight}>${item.total.toFixed(2)}</Text>
              </View>
            ))}
          </View>
        </View>

        <View style={sharedStyles.summary}>
          <View style={sharedStyles.summaryBox}>
            <View style={sharedStyles.summaryRow}>
              <Text style={sharedStyles.summaryLabel}>Subtotal:</Text>
              <Text style={sharedStyles.summaryValue}>${data.subtotal?.toFixed(2) || '0.00'}</Text>
            </View>
            {data.taxRate > 0 && (
              <View style={sharedStyles.summaryRow}>
                <Text style={sharedStyles.summaryLabel}>Tax ({data.taxRate}%):</Text>
                <Text style={sharedStyles.summaryValue}>${data.tax?.toFixed(2) || '0.00'}</Text>
              </View>
            )}
            <View style={sharedStyles.summaryTotal}>
              <Text style={sharedStyles.summaryTotalLabel}>Grand Total:</Text>
              <Text style={sharedStyles.summaryTotalValue}>${data.grandTotal?.toFixed(2) || '0.00'}</Text>
            </View>
          </View>
        </View>

        {data.notes && (
          <View style={sharedStyles.notes}>
            <Text style={sharedStyles.notesTitle}>Notes:</Text>
            <Text style={sharedStyles.notesText}>{data.notes}</Text>
          </View>
        )}

        <View style={sharedStyles.footer}>
          <Text>© 2025 Software Development East Africa (SODEAF) — Innovating for a smarter Africa.</Text>
          <Text>Crafted by Eng. Mohamed Ibrahim Abdi (Moha-Qadar) | mohamedqadar280@gmail.com</Text>
        </View>
      </Page>
    </Document>
  );
};

export default TerziReportPDF;
